import type { WorkPackageStatus, WorkTaskStatus } from "@common/client"
import {
  StatusGlyph,
  type StatusKind,
} from "@/routes/_layout/quotes/-components/status-glyphs"
import { statusLabel, taskStatusLabel } from "../-lib/status"

export const TASK_KIND: Record<WorkTaskStatus, StatusKind> = {
  not_started: "draft",
  in_progress: "in_progress",
  on_hold: "paused",
  awaiting_parts: "waiting",
  complete: "done",
  signed_off: "verified",
  deferred: "skipped",
  closed: "verified",
}

export function TaskStatusIcon({
  status,
}: {
  status: WorkTaskStatus
}): React.ReactElement {
  return (
    <StatusGlyph kind={TASK_KIND[status]} label={taskStatusLabel(status)} />
  )
}

const WORK_ORDER_KIND: Record<WorkPackageStatus, StatusKind> = {
  draft: "draft",
  scheduled: "pending",
  in_progress: "in_progress",
  complete: "done",
  closed: "verified",
  cancelled: "cancelled",
}

export function WorkOrderStatusIcon({
  status,
}: {
  status: WorkPackageStatus
}): React.ReactElement {
  return (
    <StatusGlyph kind={WORK_ORDER_KIND[status]} label={statusLabel(status)} />
  )
}
